// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__3PFir","contentStyles":"styles_contentStyles__3IFst","videoContainer":"styles_videoContainer__GiIDh","video":"styles_video__3303G"};